export default "/JMMMU/business.75ff16da-bb0608.jpg";